// extracted by mini-css-extract-plugin
export default {"root":"gBGVVY6hfmGcojZq5qad","isFullWidth":"Fe5iMyaTgZuplunr4JMm","isMultiline":"SaJpIM3F0eFBO0EwX18f"};